import { useFormContext } from 'react-hook-form';
import styled from 'styled-components';

import { addInteractionEvent } from '@creditornot/browser-telemetry';
import { Button } from '@creditornot/cb-button';
import { WoltWarehouseItem } from 'common/api-types/warehouse';
import { ContentContainer } from 'common/components/cookbook/ContentContainer';
import { useFormatMessage } from 'common/hooks/useFormatMessage';

const Root = styled(ContentContainer)`
  display: flex;
  justify-content: flex-end;
  padding-top: 16px;
  gap: 16px;
`;

type Props = {
  selectedItem: WoltWarehouseItem;
  selectedWarehouseId: string;
  onClose: (preserveQueryParams?: boolean) => void;
  isSubmitting?: boolean;
};

type ClickTarget = 'add_to_inventory' | 'cancel';

export const ButtonRow = ({ selectedItem, selectedWarehouseId, onClose, isSubmitting }: Props) => {
  const { getValues } = useFormContext();
  const formatMessage = useFormatMessage();

  const addClickEvent = (target: ClickTarget) => {
    const quantity = getValues('quantity');
    const location = getValues('locationName');

    addInteractionEvent('add_to_inventory', 'click', {
      wm_venue_id: selectedWarehouseId,
      item_id: selectedItem?.id,
      gtin: selectedItem?.gtin,
      quantity,
      location,
      click_target: target,
    });
  };

  return (
    <Root>
      <Button
        size="large"
        stretch={true}
        data-test-id="cancel-receive-button"
        onClick={() => {
          onClose(true);
          addClickEvent('cancel');
        }}
        variant="secondary"
      >
        {formatMessage('common.cancel')}
      </Button>
      <Button
        type="submit"
        size="large"
        stretch={true}
        variant="primary"
        data-test-id="add-to-inventory-button"
        onClick={() => addClickEvent('add_to_inventory')}
        disabled={isSubmitting}
      >
        {formatMessage('common.add')}
      </Button>
    </Root>
  );
};
